// src/utils/api.js
// Detects whether the app is running natively (iOS/Android via Capacitor)
// or in a browser, and sets the API base URL accordingly.
//
// Native: all /api/ calls must be absolute (https://gametrait.com/api/...)
//         because the WebView loads from the local bundle, not gametrait.com
//
// Web:    relative URLs work fine (/api/... resolves against gametrait.com)
//
// Usage:
//   import { apiFetch } from "../utils/api";
//   const res = await apiFetch("/api/discover?browse=true");

import { Capacitor } from "@capacitor/core";

export var API_BASE = (function() {
  try {
    return Capacitor.isNativePlatform() ? "https://gametrait.com" : "";
  } catch (e) {
    return "";
  }
})();

export function apiFetch(url, options) {
  return fetch(API_BASE + url, options);
}